import { getAttributeOrThrow, qsOptional } from '@/scripts/core/global';
import { UcoastEl } from '@/scripts/core/UcoastEl';
import { mediaLoader } from '@/scripts/core/global';
import { SliderComponent } from '@/scripts/theme/slider-component';

export class ProductRecommendations extends UcoastEl {
  static htmlSelector = 'product-recommendations';
  private recommendationsObserver?: IntersectionObserver;
  private request?: AbortController;
  constructor() {
    super();
  }

  override connectedCallback() {
    const handleIntersection = (entries:IntersectionObserverEntry[], observer:IntersectionObserver) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      const fetchUrl = getAttributeOrThrow('data-url', this);

      this.request = new AbortController();
      fetch(fetchUrl, { signal: this.request.signal })
        .then((response) => {
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = qsOptional<ProductRecommendations>('product-recommendations', html)

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            customElements.whenDefined(SliderComponent.htmlSelector).then(() => {
              if (!this.isConnected) return;
              this.querySelectorAll<SliderComponent>('slider-component').forEach((slider) => slider.resetPages());
            });
            mediaLoader()
          } else {
            this.replaceChildren();
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          if (e.name === 'AbortError') return;
          console.error(e);
        });
    };

    this.recommendationsObserver = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' });
    this.recommendationsObserver.observe(this);
  }

  override disconnectedCallback() {
    super.disconnectedCallback();
    this.recommendationsObserver?.disconnect();
    this.request?.abort();
  }
}
